import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { isEmpty } from 'lodash';

@Injectable(
  {providedIn: 'root'}
)

export class CustomerAuthGaurd{

  constructor(private router:Router) {}

  canActivate(next:ActivatedRouteSnapshot, state: RouterStateSnapshot){
    let customerToken = sessionStorage.getItem('customerToken');
    if(!isEmpty(customerToken)){
      return true;
    } else{
      this.router.navigateByUrl('/');
      return false;
    }
  }

}